import { PropsWithChildren } from "react";
import useIsLoggedIn from "ui/auth/hooks/useIsLoggedIn";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import ProtectedRoute from "ui/router/components/ProtectedRoute/ProtectedRoute";
import getQueryParams from "ui/router/utils/getQueryParams";
import { TransactionsRoutes } from "ui/transactions/router/TransactionsRouter";

const LoggedOutRoute = ({ children }: PropsWithChildren<object>): JSX.Element => {
    const isLoggedIn = useIsLoggedIn();

    return (
        <ProtectedRoute isAllowed={!isLoggedIn} redirectPath={redirectionGuard(MainRoutes.MAIN)}>
            {children}
        </ProtectedRoute>
    );

    function redirectionGuard(redirectPath: string): string {
        const params = getQueryParams();
        if (!params.destinationAddress) {
            return redirectPath;
        }
        return `${TransactionsRoutes.SEND_DETAILS}`;
    }
};

export default LoggedOutRoute;
